<template>
  <div class="baseWindows">
    <van-swipe ref="TopSwipe" :autoplay="6000" @change="onTopSwipe">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img :src="image.img" style="width:100%" @click="topAdClick(image.url)">
      </van-swipe-item>
      <div slot="indicator" class="custom-indicator swipeTop">
        <span v-for="(image, index) in images" :key="index" @click="gotoTopSwipe(index)">
          <a v-if="NowTopSwipe == index" class="mainColor"><i class="iconfont iconline" /></a>
          <a v-if="NowTopSwipe != index"><i class="iconfont iconline" /></a>
        </span>
      </div>
    </van-swipe>
    <div class="topSearchBar">
      <van-row>
        <van-col span="4">搜索</van-col>
        <van-col span="18"><input v-model="searchKey" type="text" class="inputSearch"></van-col>
        <van-col span="2" class="textRight"><i class="iconfont iconsearchs iconrightsmall" @click="onSearch" /></van-col>
      </van-row>
    </div>

    <!-- <div class="InfoRect">
      <div class="lineTitle">
        <span>| 课程推荐</span>
      </div>
      <div class="courseRecommend">
        <van-row gutter="20">
          <van-col v-for="item in CourseRecommend" :key="item.id" span="12">
            <div class="coursetitle">
              {{ item.cat }}
            </div>
            <img :src="item.image" @click="onShowCouresAbout(item)">
            <div class="more" @click="onShowCouresAbout(item)">了解更多<i class="iconfont iconrightsmall" /></div>
          </van-col>
        </van-row>
      </div>
    </div> -->
    <div class="InfoRect">
      <div class="lineTitle">
        <span>| 潜店推荐</span>
        <div class="moreButton" @click="onDiveStoreMore">更多<i class="iconfont iconrightsmall" /></div>
      </div>
      <div class="diveShopRecommend">
        <van-row gutter="20">
          <van-col v-for="item in DiveStore" :key="item.id" span="8">
            <img :src="item.image" @click="onDiveStore(item.id)">
            <div class="dsName" @click="onDiveStore(item.id)">
              {{ item.title }}
            </div>
            <div class="dsAddress" @click="onDiveStore(item.id)">
              {{ item.address }}
            </div>
          </van-col>

        </van-row>
      </div>
    </div>

    <div class="InfoRect">
      <div class="lineTitle">
        <span>| SSI全球潜水中心</span>
        <div class="moreButton" @click="onGlobalDiveCenterMore">更多<i class="iconfont iconrightsmall" /></div>
      </div>
      <div class="globleDc">
        <div v-for="item in globalDiveCenter" :key="item.diveCenterId">
          <div class="rect" @click="onGlobalDiveCenter(item.diveCenterId)">
            <van-row gutter="20">
              <van-col span="5">
                <img :src="item.icon">
              </van-col>
              <van-col span="19">
                <div class="title">{{ item.title }}</div>
                <div class="address">{{ item.address }}</div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>

    <div class="InfoRect">
      <div class="lineTitle">
        <span>| 我的教材</span>
        <div class="moreButton" @click="onProgram">更多<i class="iconfont iconrightsmall" /></div>
      </div>
      <div class="myProgram">
        <van-row v-if="MyProgram.isGet" gutter="20">
          <van-col span="12">
            <div v-for="(item, index) in MyProgram.list" :key="index">
              <img v-if="index%2==0" :src="item" class="programBack" @click="onProgram">
            </div>
          </van-col>
          <van-col span="12">
            <div v-for="(item, index) in MyProgram.list" :key="index">
              <img v-if="index%2==1" :src="item" class="programBack" @click="onProgram">
            </div>
          </van-col>
        </van-row>
        <van-row v-if="!MyProgram.isGet" gutter="20">
          <van-col span="12">
            <div v-for="(item, index) in MyProgram.list" :key="index" @click="onProgram">
              <div v-if="index%2==0" class="programBack" @click="onProgram">
                <img :src="item" @click="onProgram">
                <div class="programTop" @click="onProgram"><div>现在注册免费获得</div></div>
              </div>
            </div>
          </van-col>
          <van-col span="12">
            <div v-for="(item, index) in MyProgram.list" :key="index" @click="onProgram">
              <div v-if="index%2==1" class="programBack" @click="onProgram">
                <img :src="item" @click="onProgram">
                <div class="programTop" @click="onProgram"><div>现在注册免费获得</div></div>
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>

    <!-- <div class="InfoRect">
      <div class="lineTitle">
        <span>| 课程产品</span>
        <div class="moreButton" @click="onStoreCourseMore">更多<i class="iconfont iconrightsmall" /></div>
      </div>
      <div class="commodityRect">
        <div v-for="item in StoreCourse.rows" :key="item.id" class="commodity">
          <van-row>
            <van-col span="7"><img class="icon" :src="item.icon" @click="inCommodity(item.id)"></van-col>
            <van-col span="1" />
            <van-col span="16">
              <div class="pageTitle1 title" @click="inCommodity(item.id)">{{ item.title }}</div>
              <div class="downRect1" @click="inCommodity(item.id)"><span class="price">￥{{ item.lowPrice }}</span><span class="pagebody2 aboutStr">月售{{ item.sellNum }} | 评价{{ item.commentNum }}</span></div>
              <div class="downRect"><span class="pagebody2 aboutStr">{{ item.shopName }}</span><span class="pagebody2" @click="inShop(item.shopId)">&nbsp;&nbsp;进店>></span></div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div> -->
    <div class="emptyRect" />
    <NativeBar select="home" />

    <van-popup v-if="selectCourse" v-model="showPopupCourse" class="PopupCourse">
      <div class="title"> {{ selectCourse.program }}</div>
      {{ selectCourse.description }}
      <van-button type="info" @click="onGotoCourseList(selectCourse)">在商城中查看该课程</van-button>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Swipe, SwipeItem, Popup, Button } from 'vant'
import NativeBar from '@/components/NativeBar'
import { initPage } from '@/utils/base'
export default {
  name: 'HomePage',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Popup.name]: Popup,
    [Button.name]: Button,
    NativeBar
  },
  data() {
    return {
      offsetTop: 0,
      NowTopSwipe: 0,
      searchKey: '',
      images: [
        {
          img: '/img/home/8.jpg',
          url: 'wechatNew'
        }
        // {
        //   img: '/img/home/6.jpg',
        //   url: '/activity/group'
        // },
        // {
        //   img: '/img/home/7.jpg',
        //   url: '/activity/raffle'
        // }

      ],
      CourseRecommend: [],
      showPopupCourse: false,
      selectCourse: undefined,
      globalDiveCenter: [],
      MyProgram: [],
      StoreCourse: [],
      DiveStore: []
    }
  },
  activated() {
    // keep-alive组件 页面进入的时候设置滚动高度
    console.log('activated', this.offsetTop)
    document.documentElement.scrollTop = this.offsetTop
    initPage()
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  created() {
    initPage()
    this.initCourseRecommend()
    this.initGlobalDiveCenter()
    this.initMyProgram()
    this.initStoreCourse()
    this.initDiveStore()
    // request({
    //   url: '/user/index',
    //   method: 'post',
    //   params: { id: 0 }
    // }).then(response => {
    //   this.test = response
    // })
  },
  methods: {
    onSearch() {
      if (!this.searchKey || this.searchKey.length <= 0) {
        return
      }
      this.$router.replace('/store/index?serKey=' + this.searchKey)
    },
    initCourseRecommend() {
      request({
        url: '/Home/getHomeRecommendProgram',
        method: 'post'
      }).then(response => {
        this.CourseRecommend = response.data
      })
    },
    onShowCouresAbout(item) {
      this.showPopupCourse = true
      this.selectCourse = item
    },
    onGotoCourseList(selectCourse) {
      this.$router.replace('/store/index?courseId=' + selectCourse.id)
    },
    topAdClick(url) {
      if (url !== undefined) {
        if (url.indexOf('/') === 0) {
          this.$router.replace(url)
        } else {
          this.$router.replace('/home/staticPage/' + url + '?backurl=/users/index')
        }
      }
    },
    initGlobalDiveCenter() {
      request({
        url: '/Home/getGlobalDiveCenter',
        method: 'post'
      }).then(response => {
        this.globalDiveCenter = response.data
      })
    },
    onGlobalDiveCenter(diveCenterId) {
      this.$router.replace('/store/globaldivecenter/' + diveCenterId + '?backurl=/home/index')
    },
    onGlobalDiveCenterMore() {
      this.$router.replace('/store/globaldivecenterList?backurl=/home/index')
    },
    initMyProgram() {
      request({
        url: '/Home/getMyProgram',
        method: 'post'
      }).then(response => {
        this.MyProgram = response.data
      })
    },
    onProgram() {
      this.$router.replace('/textbook/index')
    },
    initStoreCourse() {
      request({
        url: '/Home/getStoreCourse',
        method: 'post'
      }).then(response => {
        this.StoreCourse = response.data
      })
    },
    inShop(id) {
      this.$router.replace('/store/commodityList/' + id + '?backurl=/home/index')
    },
    inCommodity(id) {
      this.$router.replace('/store/commodity/' + id + '?backurl=/home/index')
    },
    onStoreCourseMore() {
      this.$router.replace('/store/index')
    },
    initDiveStore() {
      request({
        url: '/Home/getRecommendDiveStore',
        method: 'post'
      }).then(response => {
        this.DiveStore = response.data
      })
    },
    onDiveStore(id) {
      this.$router.replace('/store/diveshop/' + id + '?backurl=/home/index')
    },
    onDiveStoreMore() {
      this.$router.replace('/store/diveshopList?backurl=/home/index')
    },
    onTopSwipe(index) {
      this.NowTopSwipe = index
    },
    gotoTopSwipe(index) {
      this.NowTopSwipe = index
      this.$refs.TopSwipe.swipeTo(index)
    }
  }
}
</script>
<style scoped>
.baseWindows{
  position: relative;
}
.emptyRect{
  height: 3em;
}
.topSearchBar{
  position: absolute;
  left:1em;
  right: 1em;
  top:1em;
  height: 2.5em;
  line-height: 2.5em;
  color:#ccc;
  background-color: rgba(0,0,0,0.5);
  padding: 0 0.5em;
  z-index: 10;
  font-size: 0.9em;
}
.topSearchBar .inputSearch{
  height:1.3em;
  width: 100%;

  background-color: transparent;
  border: none;
}

.InfoRect{
  padding: 0.8em 0 0 0;

}
.InfoRect .lineTitle{
  padding: 0 1em;
  line-height: 3em;
  font-weight: 700;
  position: relative;
    background-color: #fff
}
.InfoRect .lineTitle span{
  font-size: 1.1em;
  letter-spacing:5px;
}
.InfoRect .lineTitle .moreButton{
  position:absolute;
  right: 1em;
  top: 0;
  bottom: 0;
  font-size: 0.8em;
  color: #c4c4c4;
}

.courseRecommend{
  background-color: #fff;
  padding: 0 0.7em;

}
.courseRecommend .line{
  border-right: 1px solid #e4e4e4;
  }

.courseRecommend .coursetitle{
  font-weight: 700;
  font-size: 0.9em;
  margin-bottom: 0.5em;
}
.courseRecommend img{
  width: 100%
}
.courseRecommend .more{
  float: right;
  font-size: 0.7em;
  color: #c4c4c4;
  line-height: 3em;
}
.diveShopRecommend
{
  padding:  1em;
  background-color: #fff;
}
.diveShopRecommend img{
  width: 100%
}
.diveShopRecommend .dsName{
  font-size: 0.9em;
      text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 2em;
}
.diveShopRecommend .dsAddress
{
  font-size: 0.8em;
      text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.myProgram{
   padding:  1em;
  background-color: #fff;
}
.myProgram img{
  width: 100%;
  vertical-align:top;
}
.myProgram .programBack
{
  margin: 0.5em 0;
  position: relative;
}
.myProgram .programBack .programTop{
  position: absolute;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  color: #ddd;
  text-align: center;
  line-height: 7em;  background-color: rgba(0,0,0,0.5);
}
 /* <div class="programBack">
                <img v-if="index%2==0" :src="item">
                <div class="programTop">即可注册免费获得</div>
              </div> */
.globleDc
{
   padding:  1em;
  background-color: #fff;
}
.globleDc img{
  width: 100%;
}
.globleDc .rect{
 position: relative;
 padding: 0.4em 0 ;
 border-bottom: 1px solid #e4e4e4
}
.globleDc .rect .title{
  font-size: 0.9em;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.globleDc .rect .address{
  font-size: 0.8em;
  margin-top: 0.8em;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.commodityRect{
     padding: 0.1em 1em;
  background-color: #fff;

}
.commodity{

     border-bottom: 1px solid #dadada;
    margin: 1em 0;
    padding-bottom: 1em;
    position: relative;
}
.commodity .icon{
    width: 100%;
}
.commodity .downRect{
    position: absolute;
    bottom: 1.2em;
    left: 33%;
    right: 0;
}
.commodity .downRect1{
    position: absolute;
    bottom: 2.7em;
    left: 33%;
    right: 0;
}
.commodity .downRect1 .price{
    color:#E32119;
    font-weight: 700;
    margin-right: 1.5em;
}
.commodity .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.PopupCourse{
  width: 80%;
  padding:1em;
}
.PopupCourse .title{
  font-weight: 700;
  line-height: 3em;
}

.PopupCourse button{
  margin-top:1em;
  width: 100%;
}
</style>
